import {
  ActivityType,
  Correctness,
  QuestionTypes,
} from '@showbie-socrative/socrative-utils';

import {
  QuestionTypes as AnalyticsQuestionTypes,
  RoomTypes,
} from '~analytics/types';

import { sendGradeModifiedEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class GradeModifiedEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendGradeModifiedEvent;

  constructor(
    isRostered: boolean,
    props: {
      question_type: QuestionTypes;
      question_weight: number;
      original_correctness: Correctness;
      modified_correctness: Correctness;
      original_score: number;
      modified_score: number;
      activity_type: ActivityType;
      activity_student_count: number;
      activity_question_count: number;
      activity_end_date: Date;
    }
  ) {
    super();

    try {
      this.eventData = {
        question_type: this.mapQuestionType(props.question_type),
        question_weight: props.question_weight,
        original_correctness: this.mapCorrectness(props.original_correctness),
        modified_correctness: this.mapCorrectness(props.modified_correctness),
        original_score: props.original_score,
        modified_score: props.modified_score,
        activity_type: props.activity_type,
        activity_student_count: props.activity_student_count,
        activity_question_count: props.activity_question_count,
        activity_room_type: isRostered
          ? RoomTypes.RosteredRoom
          : RoomTypes.OpenRoom,
        activity_end_date: props.activity_end_date,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }

  mapCorrectness(correctness: Correctness) {
    switch (correctness) {
      case Correctness.Partial:
        return 'partial';
      case Correctness.Correct:
        return 'correct';
      case Correctness.Incorrect:
        return 'incorrect';
      default:
        return null;
    }
  }

  mapQuestionType(questionType: QuestionTypes) {
    switch (questionType) {
      case QuestionTypes.TrueFalse:
        return AnalyticsQuestionTypes.TrueFalse;
      case QuestionTypes.MultipleChoice:
        return AnalyticsQuestionTypes.MultipleChoice;
      case QuestionTypes.FreeResponse:
        return AnalyticsQuestionTypes.ShortAnswer;
      default:
        return null;
    }
  }
}
